import { BaseFormComponent } from 'src/app/shared/components/base-form-component/base-form-component';
import { Component, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { Size } from '../models/size.model';
import { SizeService } from '../services/size.service';

@Component({
    selector: 'ng-size-form',
    templateUrl: 'size-form.component.html'
})

export class SizeFormComponent extends BaseFormComponent<Size> {

    constructor(protected injector: Injector, protected sizeServ: SizeService) {
        super(injector, 'size', '/admin/settings/size', Size.fromJsonToObject, sizeServ);
    }

    protected buildForm(): void {
        this.objectForm = this.formBuilder.group({
            size:this.formBuilder.control('',[Validators.required]),
            description:this.formBuilder.control('',[Validators.required]),
            id: this.formBuilder.control(null),
        })
    }

    protected initChildProprieties(): void { }
    protected initChildMethods(): void { }
}